import{v4 as r}from"uuid";import o from"short-unique-id";var i=new o,n=function(o){return o?i.randomUUID(o):r()};export{n as generateId};
